var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loader',{staticClass:"full-page-loader",attrs:{"position":"fixed"}})
}
var staticRenderFns = []

export { render, staticRenderFns }